import React from 'react';
import { Box, Typography, List, ListItem, ListItemText } from '@mui/material';

export const SelectVideo: React.FC = () => {
  return (
    <Box>
      <Typography variant="h6">Select a video from the list:</Typography>
      {/* <List>
        <ListItem>
          <ListItemText primary="Sample Video 1" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Sample Video 2" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Sample Video 3" />
        </ListItem>
      </List> */}
    </Box>
  );
};
